import { render, staticRenderFns } from "./FileReaderInput.vue?vue&type=template&id=5b72d7d2&scoped=true&"
import script from "./FileReaderInput.vue?vue&type=script&lang=ts&"
export * from "./FileReaderInput.vue?vue&type=script&lang=ts&"
import style0 from "./FileReaderInput.vue?vue&type=style&index=0&id=5b72d7d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b72d7d2",
  null
  
)

export default component.exports